import { array, option, record } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { createSelector } from 'reselect';

import { GeneralServiceDocumentType as ServiceDocumentType } from '@mews-distributor/data-access';
import { getProp, getStringProp, values } from '@mews/fp';

import { ApplicationState } from '../../../types';
import { getEntities } from '../getEntities';

const getServiceDocuments = createSelector(getEntities, (entities) => entities.serviceDocuments);

const getServiceDocumentsData = createSelector(getServiceDocuments, (documents) => documents.data);

const getServiceTypeDocument = createSelector(
    getServiceDocumentsData,
    getStringProp('serviceId'),
    getProp<ServiceDocumentType>()('type'),
    (documents, serviceId, type) =>
        pipe(
            documents,
            values,
            array.filter((document) => document.serviceId === serviceId && document.type === type),
            array.head
        )
);

const hasServiceTypeDocument = flow(getServiceTypeDocument, option.isSome);

interface HasServiceTypesDocumentsProps {
    serviceId: string;
    types: ServiceDocumentType[];
}
export const hasServiceTypesDocuments = (
    state: ApplicationState,
    { types, serviceId }: HasServiceTypesDocumentsProps
) =>
    pipe(
        types,
        array.every((type) => hasServiceTypeDocument(state, { serviceId, type }))
    );

export const getServiceTypeDocumentMarkdownValues = flow(
    getServiceTypeDocument,
    option.flatMap(({ markdownValues }) =>
        markdownValues == null || record.isEmpty(markdownValues) ? option.none : option.some(markdownValues)
    )
);
